import { render, staticRenderFns } from "./RenyuanAdd.vue?vue&type=template&id=6a3a3fd4&scoped=true"
import script from "./RenyuanAdd.vue?vue&type=script&lang=js"
export * from "./RenyuanAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3a3fd4",
  null
  
)

export default component.exports